// extracted by mini-css-extract-plugin
export default {"container":"style_container__uSqis","headerIcon":"style_headerIcon__x2HXd","body":"style_body__aL4J8","btn":"style_btn__9NskE"};